import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {getRoles, GetMenuHeader, GetMenuHeaderByGroup, validateUrl} from '../../functions';
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../constants';
import $ from 'jquery';
import TipoObjetoSelect from './notificaciones/TipoObjetoSelect';
import TipoSelect from './notificaciones/TipoSelect';
import TipoNotificacionPushSelect from './notificaciones/tipoNotificacionPushSelect';
import EstadoSelect from './notificaciones/EstadoSelect';
import { Pagination } from '../Elements/Pagination/tablePagination';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class Notificaciones extends Component {
    
    constructor(props) {
        super(props); 
        this.state = {
            menuGeneral:  [],
            menus:        [],
            agrupador:    "Notificaciones",
            security:     cookie.load('user'),
            roles:        [],
            data:         [],
            pagina:       1,

            filtros:      {
                tipoObjeto:             null,
                tipo:                   null,
                tipoNotificacionPush:   null,
                estado:                 null
            },

            reenviando:  false
        }
    }

    getData = (page = "1") => {
        console.log("page", page);

        const filters = this.state.filtros;
        let filterTipoObjeto        = filters.tipoObjeto === null ? "X" : filters.tipoObjeto.value;
        let filterTipo              = filters.tipo === null ? "X" : filters.tipo.value;
        let tipoNotificacionPush    = filters.tipoNotificacionPush === null ? "X" : filters.tipoNotificacionPush.value;
        let estado                  = filters.estado === null ? "X" : filters.estado.value;

        const url = `${API_URL}NotificacionUX/${page}/${filterTipoObjeto}/${filterTipo}/${tipoNotificacionPush}/${estado}`;
        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            console.log('notificaciones', data);

            this.setState({ 
              data: data.result, 
              response: data, 
              error: data.Error, 
              // roles : roles, 
              pagina: page, 
            });
  
            // this.ShowPaginationFive(0);
            // document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    changeFilters = (value, name) => {
        let filters     = this.state.filtros;
        filters[name]   = value;

        // console.log(filters);

        this.setState({
            filtros: filters
        }, () => {
            this.getData();
        });
    }

    componentDidMount(){        
        this.getData();
    }

    verNotificacion(notificacionId){
        this.props.history.push(`/notificaciones/${notificacionId}`);
    }

    reenviarNotificacion(notificacionId){
        console.log(notificacionId);
        const url = `${API_URL}NotificacionUX/ReenviarNotificacion/${notificacionId}`;
            this.setState({
                reenviando: true
            });

            axios.post(
                url,
                JSON.stringify(""),
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                    }
                }
            ).then(data => {
                console.log(data);
                this.setState({
                    reenviando: false
                });
                if(data.data.isSucess){
                    this.props.history.push(`/notificaciones/${notificacionId}`);
                    toast.success('Notificación reenviada con éxito');
                }else{
                    if(data.data.result && data.data.result.length > 0){
                        toast.error(data.data.result);
                    }
                }
            }).catch((error)=> {
                console.error(error);
                toast.error(error.message);
                this.setState({
                    reenviando: false
                });
            });
    }

    render() {

        console.log(API_URL);

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon home" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <span> / Notificaciones</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Notificaciones
                </div>
                <div className="divSector_Panel">
                    <div className="tabla-filters">
                        <div className='row'>
                            <div className='col col-md-6 col-lg-3'>
                                <TipoObjetoSelect 
                                    value={this.state.filtros.tipoObjeto}
                                    onChange={(value) => this.changeFilters(value, 'tipoObjeto')}
                                />
                            </div>
                            <div className='col col-md-6 col-lg-3'>
                                <TipoSelect 
                                    value={this.state.filtros.tipo}
                                    onChange={(value) => this.changeFilters(value, 'tipo')}
                                />
                            </div>
                            <div className='col col-md-6 col-lg-3'>
                                <TipoNotificacionPushSelect 
                                    value={this.state.filtros.tipoNotificacionPush}
                                    onChange={(value) => this.changeFilters(value, 'tipoNotificacionPush')}
                                />
                            </div>
                            <div className='col col-md-6 col-lg-3'>
                                <EstadoSelect
                                    value={this.state.filtros.estado}
                                    onChange={(value) => this.changeFilters(value, 'estado')}
                                />
                            </div>
                        </div>
                    </div>
                    <Link to={`/notificaciones/crear/nueva`} className='btn btn-large btn-primary mt-3'>
                        Crear notificación
                    </Link>
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                            <tbody>
                                <tr>
                                    <th>#</th>
                                    <th>Tipo objeto</th>
                                    <th>ID Recurso/Boletín</th>
                                    <th>Tipo</th>
                                    <th>Tipo notificación push</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
                                </tr>
                                {
                                    this.state.data.length > 0 ? 
                                    this.state.data.map((item, index) => (
                                        <tr key={`notificacion-${index}`}>
                                            <td>{item.noti_Id}</td>
                                            <td>{item.noti_TipoObjeto}</td>
                                            <td>{item.noti_ObjetoId}</td>
                                            <td>{item.noti_Tipo}</td>
                                            <td>{item.noti_TipoNotificacionPush}</td>
                                            <td>{item.noti_Estado}</td>
                                            <td>
                                                <div className="divNotificacionesBtnAcciones">
                                                    <OverlayTrigger
                                                    //key={placement}
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-top-reenviar`}>
                                                        Reenviar
                                                        </Tooltip>
                                                    }
                                                    >
                                                    <button className='btnaction' disabled={this.state.reenviando} type="button" key = {index}
                                                        onClick = {() => { this.reenviarNotificacion(item.noti_Id) }}
                                                    >
                                                        <i className='fas fa-share'></i>
                                                    </button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                    //key={placement}
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-top-editar`}>
                                                        Ver
                                                        </Tooltip>
                                                    }
                                                    >
                                                    <button  className='btnaction' type="button"
                                                        onClick={() => this.verNotificacion(item.noti_Id)}
                                                    >
                                                        <i className='fas fa-eye'></i>
                                                    </button>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td colSpan="5" className="tdSinResultados">
                                            No se encontró resultados.
                                        </td>
                                    </tr>                              
                                }
                            </tbody>
                        </table>
                        {this.state.data.length > 0 &&
                            <Pagination
                                data={this.state.data}
                                pagina={this.state.pagina}
                                changePage={(page) => this.getData(page)}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}